import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";

export default function Browse({ title = "Music Videos" }) {
  const [videos, setVideos] = useState([]);
  const [genres, setGenres] = useState([]);
  const [moods, setMoods] = useState([]);
  const [sp, setSp] = useSearchParams();
  const genre = sp.get("genre") || "";
  const language = sp.get("language") || "";
  const mood = sp.get("mood") || "";
  const sort = sp.get("sort") || "recent";
  const q = sp.get("q") || "";

  useEffect(() => { api.get("/genres").then((r) => setGenres(r.data)); }, []);
  useEffect(() => { api.get("/moods").then((r) => setMoods(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const params = new URLSearchParams();
    if (genre) params.set("genre", genre);
    if (language) params.set("language", language);
    if (mood) params.set("mood", mood);
    if (q) params.set("q", q);
    params.set("sort", sort);
    params.set("limit", "60");
    api.get(`/videos?${params}`).then((r) => setVideos(r.data));
  }, [genre, language, mood, sort, q]);

  const setF = (k, v) => { const n = new URLSearchParams(sp); if (v) n.set(k, v); else n.delete(k); setSp(n); };

  return (
    <div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-6">{title}</h1>
      <div className="flex flex-wrap gap-3 mb-8" data-testid="browse-filters">
        <select data-testid="filter-genre" value={genre} onChange={(e) => setF("genre", e.target.value)} style={{ colorScheme: "dark" }} className="bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm focus:outline-none focus:border-cyan-400/50">
          <option value="" style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>All genres</option>
          {genres.map((g) => <option key={g.slug} value={g.slug} style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>{g.name}</option>)}
        </select>
        <select data-testid="filter-language" value={language} onChange={(e) => setF("language", e.target.value)} style={{ colorScheme: "dark" }} className="bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm focus:outline-none focus:border-cyan-400/50">
          <option value="" style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>All languages</option>
          <option style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>English</option><option style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>Japanese</option><option style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>Instrumental</option>
        </select>
        <select data-testid="filter-mood" value={mood} onChange={(e) => setF("mood", e.target.value)} style={{ colorScheme: "dark" }} className="bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm focus:outline-none focus:border-cyan-400/50">
          <option value="" style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>All moods</option>
          {moods.map((m) => <option key={m.id} value={m.name} style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>{m.name}</option>)}
        </select>
        <select data-testid="filter-sort" value={sort} onChange={(e) => setF("sort", e.target.value)} style={{ colorScheme: "dark" }} className="bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm focus:outline-none focus:border-cyan-400/50">
          <option value="recent" style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>Newest</option>
          <option value="trending" style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>Trending</option>
          <option value="popular" style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>Most liked</option>
          <option value="title" style={{ backgroundColor: "#1A1A26", color: "#FFFFFF" }}>Title A-Z</option>
        </select>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {videos.map((v) => <VideoCard key={v.id} video={v} size="sm" queue={videos} />)}
      </div>
      {!videos.length && <div className="text-zinc-500 py-20 text-center">No videos match your filters.</div>}
    </div>
  );
}
